export const columns = [
  {
    title: "签证编号",
    width: 200,
    dataIndex: "bizNo",
    key: "bizNo",
  },
  {
    title: "关联合同",
    width: 300,
    dataIndex: "contractName",
    key: "contractName",
  },
  {
    title: "项目名称",
    width: 200,
    dataIndex: "projectName",
    key: "projectName",
  },
  {
    title: "项目状态",
    width: 150,
    dataIndex: "projectStatusName",
    key: "projectStatusName",
  },
  {
    title: "签证类型",
    width: 150,
    dataIndex: "visaTypeValue",
    key: "visaTypeValue",
  },
  {
    title: "签证日期",
    width: 150,
    dataIndex: "visaDate",
    key: "visaDate",
  },
  {
    title: "签证金额（￥）",
    width: 200,
    dataIndex: "visaAmount",
    key: "visaAmount",
  },
  
];
